/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Commandautomatep12Inputs */



/**
* | output |
* | --- |
* | "Automate command left/high pump" |
*
* @param {Br_History_Key_Commandautomatep12Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_commandautomatep12 = /** @type {((inputs?: Br_History_Key_Commandautomatep12Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Commandautomatep12Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Automate command left/high pump")
	return /** @type {LocalizedString} */ ("Commande automate pompe gauche/haute")
});
export { br_history_key_commandautomatep12 as "br_history_key_commandAutomateP1" }